import type ClientsBusinessClientPerson from "@/types/serializers/ClientsBusinessClientPerson";
import type PhysicalPersonsClientLink from "@/types/serializers/PhysicalPersonsClientLink";

type RoleType = ClientsBusinessClientPerson["roles"][number];

export const ROLE_LABELS: Record<RoleType, string> = {
	ubo: "Skutečný majitel",
	statutory_member: "Člen statutárního orgánu",
};

type RelationshipType = PhysicalPersonsClientLink["relationship"];

export const RELATIONSHIP_LABELS: Record<RelationshipType, string> = {
	direct_individual: "Přímý klient (Fyzická osoba)",
	direct_entrepreneur: "Přímý klient (OSVČ)",
	ubo: "Skutečný majitel",
	statutory_member: "Člen statutárního orgánu",
	ubo_and_statutory: "Skutečný majitel, Člen statutárního orgánu",
};

const DIRECT_CLIENT_LABELS = {
	direct_individual: "Fyzická osoba",
	direct_entrepreneur: "OSVČ",
};

const RELATIONSHIP_PRIORITY: Record<RelationshipType, number> = {
	ubo: 0,
	statutory_member: 0,
	ubo_and_statutory: 0,
	direct_entrepreneur: 1,
	direct_individual: 2,
};

export function getRelationshipLabel(relationship: RelationshipType): string {
	return RELATIONSHIP_LABELS[relationship];
}

export function isDirectRelationship(
	relationship: RelationshipType,
): relationship is "direct_individual" | "direct_entrepreneur" {
	return (
		relationship === "direct_individual" ||
		relationship === "direct_entrepreneur"
	);
}

export function getClientLinkDisplayText(
	link: PhysicalPersonsClientLink,
): string {
	if (isDirectRelationship(link.relationship)) {
		return DIRECT_CLIENT_LABELS[link.relationship];
	}
	return link.client_name;
}

export function sortClientLinks(
	links: PhysicalPersonsClientLink[],
): PhysicalPersonsClientLink[] {
	return [...links].sort((a, b) => {
		const priorityDiff =
			RELATIONSHIP_PRIORITY[a.relationship] -
			RELATIONSHIP_PRIORITY[b.relationship];
		if (priorityDiff) return priorityDiff;
		return a.client_name.localeCompare(b.client_name);
	});
}
